import '../styles/Primitives.scss';

export function ListItemButton({ children, className = '', component: Component = 'button', selected = false, ...props }) {
  return <Component className={`ui-list-item-button ${selected ? 'is-selected' : ''} ${className}`.trim()} type={Component === 'button' ? 'button' : undefined} {...props}>{children}</Component>;
}

export function ListItemIcon({ children, className = '', ...props }) {
  return <span className={`ui-list-item-icon ${className}`.trim()} {...props}>{children}</span>;
}

export function ListItemText({ children, className = '', primary, ...props }) {
  return <span className={`ui-list-item-text ${className}`.trim()} {...props}><span className="ui-list-item-text__primary">{primary ?? children}</span></span>;
}

export default function List({ children, className = '', component: Component = 'ul', disablePadding = false, ...props }) {
  return <Component className={`ui-list ${disablePadding ? 'ui-list--disable-padding' : ''} ${className}`.trim()} {...props}>{children}</Component>;
}
